import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f64482a")

_pushScopeId("data-v-5f64482a")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "text" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-title" }, " 验证不成功 "),
  /*#__PURE__*/_createTextVNode(" 验证信息与原绑定不符，无法继续操作 ")
], -1)
const _hoisted_2 = { class: "btn-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LogoffModal = _resolveComponent("LogoffModal")!

  return (_openBlock(), _createBlock(_component_LogoffModal, {
    visible: _ctx.props.visible,
    onClose: _ctx.close,
    class: "account-verify-modal"
  }, {
    default: _withId(() => [
      _createVNode("div", null, [
        _hoisted_1,
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "btn confirm-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVerify && _ctx.handleVerify(...args)))
          }, " 继续验证 "),
          _createVNode("div", {
            class: "btn cancel-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
          }, " 取消 ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
})